import React from "react";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Seo } from "./components/Seo";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/sections/Hero";
import { About } from "./components/sections/About";
import { Products } from "./components/sections/Products";
import { Capacity } from "./components/sections/Capacity";
import { WhyChooseUs } from "./components/sections/WhyChooseUs";
import { Machinery } from "./components/sections/Machinery";
import { SafetyQuality } from "./components/sections/SafetyQuality";
import { Gallery } from "./components/sections/Gallery";
import { CallToAction } from "./components/sections/CallToAction";
import { Contact } from "./components/sections/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="23vkzcrxgytqi">
      <Seo data-id="element-1" data-mp="23u9uspw79hyc" />
      <div className="w-full min-h-screen bg-white" data-id="element-2" data-mp="23ujho4ly78zt">
        <Navbar data-id="element-3" data-mp="3ik7fqfdqo9q4" />
        <main data-id="element-4" data-mp="3ikr0s4yore8d">
          <Hero data-id="element-5" data-mp="3iiwasc8k4vxf" />
          <About data-id="element-6" data-mp="3ijfthv617oci" />
          <Products data-id="element-7" data-mp="3ihuyk4ft23e4" />
          <Capacity data-id="element-8" data-mp="3mlawr57iwbsx" />
          <WhyChooseUs data-id="element-9" data-mp="3mkrbpfmkt7ao" />
          <Machinery data-id="element-10" data-mp="3mjzsz5e2v41t" />
          <SafetyQuality data-id="element-11" data-mp="3mjg8bgx1m1k3" />
          <Gallery data-id="element-12" data-mp="3rcj6y3gog175" />
          <CallToAction data-id="element-13" data-mp="3rbzomln47asl" />
          <Contact data-id="element-14" data-mp="3rcsy3udgkeef" />
        </main>
        <Footer data-id="element-15" data-mp="3relvsk63foaa" />
        <WhatsAppButton data-id="element-16" data-mp="5orv1p50w72" />
      </div>
    </LanguageProvider>;
}